import axios from "axios";
import { DateRangePicker } from "react-date-range";
import { useState, useEffect } from "react";
import PieChartOrderStage from "../PieChartOrder/PieChartOrderStage";

const OrderStage = () => {
  const baseAPI = process.env.REACT_APP_API_URL;

  const [isOrderStage, setisOrderStage] = useState(false);
  const [dateRangeStatus, setDateRangeStatus] = useState("Select Date Range");
  const [loading, setLoading] = useState(false);
  const [filterDataStage, setFilterDataStage] = useState("0");
  const [totalOrderStage, setTotalOrderStage] = useState(0);
  const [OrderStageData, setOrderStageData] = useState([]);
  const [colorsStage, setColorsStage] = useState([]);

  useEffect(() => {
    const storedToken = JSON.parse(localStorage.getItem("token"));

    if (storedToken) {     

      axios
        .get(
          `${baseAPI}userget/GetDashboardOrderStage?startDate=&enddate=&option=0`,
          {
            headers: {
              Authorization: `Bearer ${storedToken}`,
            },
          }
        )
        .then((response) => {
          if (response && response.data && response.data.data) {
            setOrderStageData(response.data.data);
            setColorsStage(generateColorsOrderStage(response.data.data));
            setTotalOrderStage(response.data.totalRecords);
            setSelectionRangeStage({
              startDate: new Date(),
              endDate: new Date(),
              key: "selection",
            });
          }
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
        });
    }
  }, []);

  const [selectionRangeStage, setSelectionRangeStage] = useState({
    startDate: null,
    endDate: null,
    key: "selection",
  });

  const toggleOrderStage = () => {
    setisOrderStage(!isOrderStage);   
  };

  const handleSelectOrderStage = (ranges) => {
    setSelectionRangeStage({
      startDate: ranges.selection.startDate,
      endDate: ranges.selection.endDate,
      key: "selection",
    });
  };

  const handleFilterStageChange = (event) => {
    setFilterDataStage(event.target.value);
  };

  function formatDate(dateString) {
    const date = new Date(dateString);
    const options = { day: "2-digit", month: "short", year: "numeric" };
    return date.toLocaleDateString("en-US", options);
  }

  function generateColorsOrderStage(data) {
    // Convert to an array if it's not already one
    const arrayData = Array.isArray(data) ? data : Array.from(data);

    const colorMapping = {};
    arrayData.forEach((item) => {
      colorMapping[item.order_stage] =
        "#" + Math.floor(Math.random() * 16777215).toString(16);
    });
    return colorMapping;
  }

  const OrderStageApplyButton = () => {
    const storedToken = JSON.parse(localStorage.getItem("token"));

    let cdate = formatDate(new Date());
    let startdate = selectionRangeStage.startDate
      ? formatDate(selectionRangeStage.startDate)
      : "";
    let enddate = selectionRangeStage.endDate
      ? formatDate(selectionRangeStage.endDate)
      : "";

    if (startdate === cdate && enddate === cdate) {
      setDateRangeStatus("Select Date Range");
      startdate = "";
      enddate = "";
    } else {
      setDateRangeStatus(startdate + " - " + enddate);
    }

    toggleOrderStage();
    if (isOrderStage) {
      setisOrderStage(!isOrderStage);
    } else {
      setisOrderStage(isOrderStage);
    }

    if (storedToken) {
      setLoading(true);
      axios
        .get(
          `${baseAPI}userget/GetDashboardOrderStage?startDate=${startdate}&endDate=${enddate}&option=${filterDataStage}`,
          {
            headers: {
              Authorization: `Bearer ${storedToken}`,
            },
          }
        )
        .then((response) => {
          setLoading(false);
          if (response && response.data && response.data.data) {
            setOrderStageData(response.data.data);
            setTotalOrderStage(response.data.totalRecords);
            setColorsStage(generateColorsOrderStage(response.data.data));
          }
        })
        .catch((error) => {
          setLoading(false);
          console.error("Error fetching user detail:", error);
        });
    }
  };

  const closeFilterOrderStage = () => {
    setisOrderStage(!isOrderStage);
  };

  return (
    <>
      <div className="outerFilterLeadStage">
        <div className="outerFilter">
          <div className="filter-icon-source">
            <img src={require("../../../Icons/filterIcon.png")} alt="filter" />
            FILTER
          </div>

          <div style={{ paddingRight: "6px" }}>
            <button
              style={{
                marginBottom: "1rem",
                width: "7rem",
                height: "2.5rem",
                borderRadius: "0.5rem",
                fontSize: "11px",
              }}
              onClick={toggleOrderStage}
            >
              {" "}
              <b> {dateRangeStatus}</b>
            </button>
            {isOrderStage && (
              <div
                style={{
                  position: "absolute",
                  zIndex: 999,
                  border: "solid 1px black",
                  marginLeft: "-6pc",
                  marginTop: "-4pc",
                  width: "35pc",
                  background: "white",
                }}
              >
                <DateRangePicker
                  ranges={[selectionRangeStage]}
                  onChange={handleSelectOrderStage}
                />

                <button
                  onClick={OrderStageApplyButton}
                  style={{
                    marginBottom: "1rem",
                    width: "8rem",
                    height: "2.5rem",
                    borderRadius: "0.5rem",
                    fontSize: "13px",
                    position: "relative",
                    top: "1px",
                    left: "17pc",
                    backgroundColor: "#5B489D",
                    color: "White",
                    border: "none",
                  }}
                >
                  Apply Filter
                </button>
                <button
                  onClick={closeFilterOrderStage}
                  style={{
                    marginBottom: "1rem",
                    width: "7.5rem",
                    height: "2.5rem",
                    borderRadius: "0.5rem",
                    fontSize: "13px",
                    position: "relative",
                    top: "1px",
                    left: "17pc",
                    color: "red",
                    backgroundColor: "white",
                    border: "none",
                    fontWeight: "bold",
                  }}
                >
                  Close
                </button>
              </div>
            )}
          </div>
          <div style={{ paddingRight: "6px" }}>
            <select
              style={{
                marginBottom: "1rem",
                width: "5rem",
                height: "2.5rem",
                borderRadius: "0.5rem",
                fontSize: "13px",
                fontWeight: "bold",
              }}
              name="filterDataStage"
              value={filterDataStage}
              onChange={handleFilterStageChange}
            >
              <option value="0">All</option>
              <option value="1">Untouched</option>
              <option value="2">Open</option>
              <option value="3">Executed</option>
              <option value="4">Cancelled</option>
              <option value="5">Abandoned</option>
            </select>
          </div>
          <div>
            <button
              style={{
                width: "6rem",
                height: "2.5rem",
                borderRadius: "0.5rem",
                fontSize: "12px",
                backgroundColor: "#5B489D",
                color: "white",
                fontWeight: "bold",
              }}
              onClick={OrderStageApplyButton}
            >
              Apply
            </button>
          </div>
        </div>

        <div className="leadSourceListButton">
          <p>
            {" "}
            <b> Total: </b>{" "}
            <span style={{ color: "#5B489D" }}>
              <b>{totalOrderStage}</b>
            </span>
          </p>
        </div>
      </div>
      <hr style={{ background: "red" }} />

      <h3
        style={{
          fontSize: "25px",
          padding: "9px",
          fontWeight: "700",
          color: "#6A6A6A",
        }}
      >
        Order stage
      </h3>
      <div style={{ display: "flex" }}>
        <div
          style={{
            width: "60%",
            display: "flex",
            marginLeft: "-3%",
          }}
        >
          <PieChartOrderStage data={OrderStageData} colors={colorsStage} />
        </div>
        <div className="Lead_stagetable" style={{ marginLeft: "10px" }}>
          <table style={{ width: "17.5rem" }}>
            <hr />

            {Array.isArray(OrderStageData) && OrderStageData.length > 0 ? (
              OrderStageData.map((item, index) => (
                <tr style={{ borderBottom: "1px solid #ccc" }} key={index}>
                  <td>
                    <ul>
                      <span
                        style={{
                          color: colorsStage[item.order_stage],
                          fontWeight: "bold",
                        }}
                      >
                        &#9679;
                      </span>{" "}
                      {item.order_stage}
                    </ul>
                  </td>
                  <td>{item.Count_relocationId}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td>No data available</td>
              </tr>
            )}
          </table>
        </div>
      </div>

        <style jsx>{`
        .filter-icon-source {
    box-shadow: 0 1px 8px rgba(0, 0, 0, 0.25);
    width: 90px;
    height: 104%;
    position: relative;
    padding: 9px;
    padding-top: 16px;
    background-color: white;
    border-radius: 9px;
    top: -4px !important;
    left: -18px;
    font-size: 12px;
}
        `}</style>
    </>
  );
};

export default OrderStage;
